import styled from "styled-components";

export const DropzoneFilesContainer = styled.div`
    display: flex;
  flex-direction: column;
  font-family: Poppins;
  p{
      color: black;
  }
`
export const DropzoneFiles = styled.div`
    width: 100%;
    padding: 5px 0;
    border: 2px dashed #CFCFCF;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #BFBFBF;
    cursor: pointer !important;
`
export const ImgFile = styled.img`
    width: 15%;
    cursor: pointer !important;
    padding: 15px;
`

export const ModalImage = styled.img`
    width: 70%;
    cursor: pointer !important;
    padding: 25px;
    border-radius: 40px;
    overflow: scroll;
    height: fit-content;
`

export const PDFView = styled.iframe`
    width: 70%;
    cursor: pointer !important;
    padding: 75px;
    border: none;
`

export const InputFile = styled.input`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer !important;
`

export const FileList = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
`

export const DivFile = styled.div`
    display: flex;
    align-items: center;
    background: #F2F2F2;
    border-radius: 2px;
    margin-top: 5px;
    margin-bottom: 20px;
    padding: 10px;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 16px;
    color: #081630;
    p{
        color: black;
    }
`

export const ImgFile2 = styled.img`
    margin-right: 10px;
    height: 40px;
    width: 40px;
    border-radius: 2px;
    object-fit: cover;
`

export const ButtonDiv = styled.button`
    margin-left: auto;
    flex-shrink: 0;
    background: rgba(255, 64, 110, 0.3);
    border: none;
    border-radius: 13px;
    width: 26px;
    height: 26px;
    color: rgba(255, 64, 110, 0.86);
`

export const LengthInfo = styled.button`
    margin-left: auto;
    flex-shrink: 0;
    background: rgba(82, 64, 255, 0.3);
    border: none;
    border-radius: 13px;
    width: 26px;
    height: 26px;
    color: rgba(81, 64, 255, 0.86);
`
